import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { css } from '@emotion/react';
import { useInitializeAuth } from '~/hooks';
import { GAEvent } from '~/utils';
import { breakpoint } from '~/styles/themes';
import { useUserStore } from '~/store';

export default function GlobalLayout() {
  useInitializeAuth();
  const location = useLocation();
  const email = useUserStore((state) => state.email);

  useEffect(() => {
    if (!email) return;
    GAEvent(email, 'page_view', {
      page_path: location.pathname + location.search + location.hash,
      page_search: location.search,
      page_hash: location.hash,
    });
  }, [location, email]);

  return (
    <div
      css={css`
        position: relative;
        width: 100%;
        max-width: ${breakpoint.mobile_large};
        height: 100%;
        margin: 0 auto;
      `}
    >
      <Outlet />
    </div>
  );
}
